export const DEFAULT_RETURN_PATH = "/manage/";
